"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var redirect = exports.redirect = function redirect(url) {
  return window.location.href = url;
};
//# sourceMappingURL=redirect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/redirect.js
// module id = 408
// module chunks = 0